let service = function (
	$q,
	_
) {
	"ngInject";

	var service = this;

	this.options = function(price) {
		var options = price.filter(function(p) {
			return p.on;
		}).reduce(function(a,b) {
			return a.concat(b.products);
		},[]);

		return $q.resolve(options);
	};

	this.interface = function(price, optionArr, allUids, process, bool) {
		var uids;
		var max = process?0:0;

		var loop = function(price, uids) {
			price.forEach((p) => {
				if (bool) {
					p.count = _.intersection(p.products, uids).length;
					p.enabled = p.count > max;
				} else {
					p.count = false;
					p.enabled = true;
				}
				
			});
		}

		if (!_.isEmpty(optionArr)) {
			uids = optionArr.reduce(function(a, b) {
				return _.intersection(a, b);
			}, allUids);

			loop(price, uids);
		} else {
			loop(price, allUids);
		}
	};
};

export default service;


// WEBPACK FOOTER //
// ./app/shared/services/price.service.js